import { MapTo } from '@adobe/aem-react-editable-components';
import PolicyTable, { PolicyTableEditConfig } from './PolicyTable';

export default MapTo('cob-corp-acquisition/components/creditonebank/policy-table')(PolicyTable, PolicyTableEditConfig);